// Bridge for Rust's `ChronicleSetupState` — intentionally domain-agnostic;
// callers map specific UI signals (e.g. onboarding modal) to this flag.
import { isTauri } from '@/tauri/utils';

class ChronicleSetupBridgeError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ChronicleSetupBridgeError';
  }
}

export const chronicleSetupBridge = {
  setActive: async (active: boolean): Promise<void> => {
    if (!isTauri()) {
      throw new ChronicleSetupBridgeError(
        'Chronicle setup bridge is only available inside the Tauri runtime'
      );
    }
    const { invoke } = await import('@tauri-apps/api/core');
    await invoke<void>('chronicle_setup_set_active', { active });
  },
};

export { ChronicleSetupBridgeError };
